export const GRAYS = ["#ffffff", "#a1a1aa", "#71717a", "#52525b", "#3f3f46", "#27272a"];
export const STATUSES = ["pending", "confirmed", "completed", "cancelled"];
export const CORP_STATUSES = ["new", "contacted", "converted", "closed"];
export const RES_STATUSES = [
  "quote_pending", "quote_sent", "awaiting_deposit", "confirmed",
  "driver_assigned", "in_progress", "completed", "cancelled", "refunded",
];

export const ChartTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-black border border-white/20 rounded-md px-3 py-2 text-xs">
      {label && <p className="text-white/60 mb-1">{label}</p>}
      {payload.map((p, i) => (
        <p key={`${p.name || p.dataKey || "series"}-${i}`} className="text-white">{p.name}: {p.value}</p>
      ))}
    </div>
  );
};

export function Stat({ icon: Icon, label, value, prefix }) {
  return (
    <div className="rounded-lg border border-white/10 bg-card p-6" data-testid={`stat-${label.toLowerCase().replace(/\s/g, "-")}`}>
      <div className="flex items-center justify-between mb-4">
        <span className="text-xs uppercase tracking-luxe text-muted-foreground">{label}</span>
        <Icon className="h-4 w-4 text-muted-foreground" />
      </div>
      <p className="font-serif text-4xl text-white">{prefix}{value}</p>
    </div>
  );
}
